import React from "react";
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const useAuth = () => {
  return !!localStorage.getItem('accessToken');
}

const PrivateRoutes = () => {
  const auth = useAuth();
  let location = useLocation();

  // If not logged in, redirect to login
  return auth ? <Outlet /> : <Navigate to="/login" replace state={{ from: location }} />;
}
export default PrivateRoutes; 